import React from 'react';
import '../Card.scss';
import './HomePageCard.scss';

interface HomePageCardProps {
  children: React.ReactNode;
  title?: string;
}

function HomePageCard({ children, title }: HomePageCardProps) {
  return (
    <div className="card card-home-page">
      {title && (
        <div className="card-home-page-header">
          <h2>{title}</h2>
        </div>
      )}
      <div className="card-home-page-body">{children}</div>
    </div>
  );
}

export default HomePageCard;
